export function pageWasRefreshed(from) {
  return from.path === '/' && !from.name
}
